<div class="display--flex">
    <div
        class="form-button help-in-place-button"
        [sklHintbox]="hintboxData">
        <a class="text--info">
            <skl-icon
                [tooltip]="tooltipData"
                color="secondary"
                shape="circle"
                name="help">
            </skl-icon>
        </a>
    </div>
</div>
